export default __webpack_public_path__ + "static/media/icon-close.8ebd6279.svg";